module.exports = __webpack_public_path__ + "img/Group368.d790a15.svg";